import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

import { BehaviorSubject, TimeoutError, Subject, Observable } from "rxjs";

import { ToastrService } from "ngx-toastr";
import { MockStoreService } from "./mock-store.service";
import { MerchantItems } from "../models/items";

import * as localForage from "localforage";
import { CookieService } from "ngx-cookie-service";
import { CommunicationCommand } from "../models/communicationCommands";

@Injectable({
  providedIn: "root"
})
export class GeneralService {
  // subject for switching on or off sidebar
  private sidebarSwitchSubject = new BehaviorSubject("off");
  public sidebarSwitcher$:
    | string
    | CommunicationCommand
    | any = this.sidebarSwitchSubject.asObservable();

  // this subject is for triggering add Item modal
  private addItemSubject = new Subject();
  public addItem$ = this.addItemSubject.asObservable();

  private singleMerchantItemSubject = new Subject();
  public singleMerchant$ = this.singleMerchantItemSubject.asObservable();

  // this observable is for getting all items or Catalogues
  private refreshSubject = new BehaviorSubject("");
  public refresh$ = this.refreshSubject.asObservable();

  // private observable for getting items for selection
  private getItemsForSelectionSubject = new BehaviorSubject("");
  public startFetchingSelectionItems$ = this.getItemsForSelectionSubject.asObservable();

  // this subject is for opening the items-selection-view from the catalogue listing component
  // it might come in handy for other purposes
  private addItemsFromCatalogueListingSubject = new BehaviorSubject("");
  public addItemsFromCatalogueListing$ = this.addItemsFromCatalogueListingSubject.asObservable();

  // observable for telling the settings Component when to
  // get the settings of logged in user
  private fetchMerchantProfileSubject = new Subject();
  public fetchMerchantProfile$ = this.fetchMerchantProfileSubject.asObservable();

  constructor(
    private toastr: ToastrService,
    private mockstore: MockStoreService,
    private cookieservice: CookieService
  ) {
    // console.log(this.sidebarSwitcher$);
  }

  sendNotificationToGetProfile(anything: any) {
    this.fetchMerchantProfileSubject.next();
  }

  // this function send notification which will be listened to by observers
  broadCastMessageToAddItemsDirectlyToCatalogueListing(anything) {
    this.addItemsFromCatalogueListingSubject.next(anything);
  }

  // abstraction function for telling listeners getItemsForSelectionSubject
  startFetchingSelectionItems(anything: string) {
    this.getItemsForSelectionSubject.next(anything);
  }

  // this function will send notification to  for refreshing catalogues
  refreshCataloguesOrItems(anything: any | MerchantItems) {
    this.refreshSubject.next(anything);
  }

  // this function will send a notification to show add item component
  additemNotification(anything) {
    this.addItemSubject.next(anything);
  }

  // this function will notify subscribers when to switch on or off the
  // sidebar
  switchSidebarOnOrOff(anything: CommunicationCommand | any): void {
    this.sidebarSwitchSubject.next(anything);
  }

  // this function will send recently added items
  singleMerchantCtrl(anything: MerchantItems) {
    this.singleMerchantItemSubject.next(anything);
  }

  handleError(error: TimeoutError | HttpErrorResponse) {
    if (error instanceof TimeoutError) {
      this.toastr.error(
        "Oops something went wrong. Please check your internet and try again",
        "Server timeout"
      );
      return;
    }
    const { message } = error.error;
    this.toastr.error(`${message}`, "Error");
  }

  handleSuccessAndNotifyUser(val: HttpResponse<any> | any) {
    this.toastr.success(`${val["message"]}`, "Success");
    // this.toastr.success(`${val}`)
  }

  // this function will scramble/encrypt a string passed to it
  encodeStuff(stuff: any) {
    if (typeof stuff == "string") {
      return window.btoa(stuff);
    }
  }
  // this function will unscramble/decrypt a encrypted word to a string encrypted by encodeStuff function
  decodeStuff(stuff): string {
    return window.atob(stuff);
  }

  setToken(token): void {
    const date = Date.now() + 86400000;
    const name = this.encodeStuff(this.mockstore.scrambledName);
    this.cookieservice.set(name, token, date);
  }

  setMerchantID(merchantID): void {
    const date = Date.now() + 86400000;
    // const name = this.encodeStuff(this.mockstore.scrambledName);
    this.cookieservice.set("merchant", merchantID, date);
  }

  getMerchantID(): string {
    const merchantID = this.cookieservice.get("merchant");
    return merchantID;
  }

  getToken(): string {
    let stuffToGet = this.encodeStuff(this.mockstore.scrambledName);
    // return await localForage.getItem(stuffToGet);
    const token = this.cookieservice.get(stuffToGet);
    return token;
    // console.log(result);
  }

  successNotification(message) {
    this.toastr.success(message, "Success");
  }

  warningNotification(message) {
    this.toastr.warning(message, "Stop");
  }

  errorNotification(message) {
    this.toastr.error(message, "Error");
  }

  async getAndDecryptPayloadData(): Promise<object> {
    let payload, token;
    try {
      token = await this.getToken();
      if (token) {
        payload = token.split(".")[1];
        payload = JSON.parse(atob(payload));
        console.log(payload);
      }
      return payload.user;
    } catch (e) {
      console.log(e);
      return;
    }
  }

  saveLoggedInUserEmail(email: string): void {
    const date = Date.now() + 86400000;
    this.cookieservice.set("email", email, date);
  }

 async saveCompletionStatus(completionStatus: object){
    await localForage.setItem('completionStatus', completionStatus);
  }

  getLoggedInUserEmail(): string {
    const string = this.cookieservice.get("email");
    return string;
  }

  async clearDataInDB(): Promise<any> {
    this.cookieservice.deleteAll();
    await localForage.clear();
  }
}
